var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activityproduct_div"
  }, [_c("a-card", {
    staticClass: "first_class",
    staticStyle: {
      "margin-top": "24px",
      flex: "1"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("activity.tips"),
      description: _vm.$t("activity.tipsContent"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }), _c("br"), _c("a-form-model", {
    ref: "rangeRuleForm",
    attrs: {
      rules: _vm.rangeRules,
      model: _vm.chooseproductparam
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("activity.commodityrange")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function change($event) {
        return _vm.rangetypeChange();
      }
    },
    model: {
      value: _vm.chooseproductparam.productType,
      callback: function callback($$v) {
        _vm.$set(_vm.chooseproductparam, "productType", $$v);
      },
      expression: "chooseproductparam.productType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.yesproduct")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.noproduct")) + " ")])], 1)], 1)], 1), _vm.chooseproductparam.productType != 0 ? _c("div", {
    staticClass: "product_div"
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")) + " ")])], 1)]), _c("a-table", {
    ref: "productList",
    attrs: {
      "row-selection": {
        onSelectAll: _vm.onSelectAll,
        onSelect: _vm.onSelect,
        onChange: _vm.onChange,
        selectedRowKeys: _vm.selectedRowKeys
      },
      rowKey: "optionId",
      pagination: {
        pageSizeOptions: ["5", "10", "20", "30"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      },
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.productList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "goodsName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_c("span", [_vm._v(_vm._s(record.productName))])]), _c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.productName) + " ")])], 2), _c("br"), _c("span", {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_vm._v(_vm._s(record.productOptionName))])], 1)]);
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: record.productStatus == 1 ? "blue" : "red"
          }
        }, [_vm._v(_vm._s(record.productStatus == 0 ? _vm.$t("offSell") : record.productStatus == 1 ? _vm.$t("onSell") : record.productStatus == 2 ? _vm.$t("publicuse.delete") : _vm.$t("public.overSell")))])], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("publicuse.suerdelete"),
            "ok-text": _vm.$t("publicuse.yes"),
            "cancel-text": _vm.$t("publicuse.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1);
      }
    }], null, false, 2199178334)
  }), this.chooseproductparam.productType != 0 ? _c("div", {
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.selected")) + _vm._s(_vm.selectNumber) + _vm._s(_vm.$t("public.term")))]), _c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.batchoperation")))]), _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.removeClick(2);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.delete")))])], 1) : _vm._e()], 1) : _vm._e()], 1), _c("footer-tool-bar", [_c("a-button", {
    staticStyle: {
      "margin-right": "16px"
    },
    on: {
      click: _vm.prevStep
    }
  }, [_vm._v(_vm._s(_vm.$t("public.previousstep")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      loading: _vm.updateLoading,
      type: "primary"
    },
    on: {
      click: _vm.nextStep
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.nextstep")) + " ")])], 1), _c("a-modal", {
    attrs: {
      width: "400px",
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.removeTypeVisible,
      callback: function callback($$v) {
        _vm.removeTypeVisible = $$v;
      },
      expression: "removeTypeVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      rules: _vm.modalRules,
      model: _vm.modalValue
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    on: {
      change: function change($event) {
        return _vm.removeTypeChange();
      }
    },
    model: {
      value: _vm.modalValue.removeType,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "removeType", $$v);
      },
      expression: "modalValue.removeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.checktheitem")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.removeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2), _c("importfailed", {
    attrs: {
      visible: _vm.importVisible,
      importObj: _vm.importObj
    },
    on: {
      "get-visible": _vm.getVisible
    }
  }), _c("selectProduct", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.alreadySelect
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };